import { render, staticRenderFns } from "./VideoIconCSS.vue?vue&type=template&id=502d6c58&scoped=true&"
import script from "./VideoIconCSS.vue?vue&type=script&lang=js&"
export * from "./VideoIconCSS.vue?vue&type=script&lang=js&"
import style0 from "./VideoIconCSS.vue?vue&type=style&index=0&id=502d6c58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502d6c58",
  null
  
)

export default component.exports